var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar" }, [
    _c(
      "div",
      { staticClass: "navbar-brand brand-small" },
      [
        _vm.isStaff
          ? _c(
              "router-link",
              { attrs: { to: { name: "dashboard" } } },
              [
                _vm.isFullMenu
                  ? _c("SaasIcon", {
                      staticClass: "white",
                      attrs: {
                        icon: "svgLogoSellsyText",
                        width: "122",
                        height: "30"
                      }
                    })
                  : _c("SaasIcon", {
                      staticClass: "white",
                      attrs: {
                        icon: "svgLogoSellsyCloud",
                        width: "36",
                        height: "26"
                      }
                    })
              ],
              1
            )
          : _c(
              "a",
              { attrs: { href: _vm.urlHome } },
              [
                _vm.isFullMenu
                  ? _c("SaasIcon", {
                      staticClass: "white",
                      attrs: {
                        icon: "svgLogoSellsyText",
                        width: "122",
                        height: "30"
                      }
                    })
                  : _c("SaasIcon", {
                      staticClass: "white",
                      attrs: {
                        icon: "svgLogoSellsyCloud",
                        width: "36",
                        height: "26"
                      }
                    })
              ],
              1
            )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "navbar-container" },
      [
        _vm._t("search"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navbar-content" },
          [
            _c(
              "ul",
              { staticClass: "nav navbar-content__actions" },
              [_vm._t("menu")],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "navbar-content__divider" }),
            _vm._v(" "),
            _vm._t("onboardingScreen"),
            _vm._v(" "),
            _c("div", { staticClass: "navbar-content__user-container" }, [
              !_vm.isStaff
                ? _c(
                    "div",
                    {
                      staticClass:
                        "navbar-content__user--profil typographies-paragraph-medium-semibold"
                    },
                    [
                      _c("div", [_vm._v(_vm._s(_vm.fullName))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "typographies-paragraph-small-regular" },
                        [_vm._v(_vm._s(_vm.corpName))]
                      )
                    ]
                  )
                : _c(
                    "a",
                    {
                      staticClass: "block navbar-content__user",
                      attrs: { href: _vm.staffUrl }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "navbar-content__user--profil typographies-paragraph-medium-semibold"
                        },
                        [
                          _c("div", [_vm._v(_vm._s(_vm.fullName))]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "typographies-paragraph-small-regular"
                            },
                            [_vm._v(_vm._s(_vm.corpName))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "navbar-content__user--profil-avatar" },
                        [
                          _vm.avatar.type === "initials"
                            ? _c("span", { staticClass: "avatar" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.avatar.value) +
                                    "\n                        "
                                )
                              ])
                            : _c(
                                "div",
                                { staticClass: "avatar avatar-picture" },
                                [
                                  _c("img", {
                                    staticClass: "pi",
                                    attrs: { src: _vm.avatar.value }
                                  })
                                ]
                              )
                        ]
                      )
                    ]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "navbar-content__divider" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "navbar-content__params" },
              [
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      slot: "reference",
                      content: _vm.$t.__("header.Nav.menu"),
                      placement: "bottom",
                      contentClass: "navbar-tooltip",
                      arrow: false
                    },
                    slot: "reference"
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.hideMenu,
                            expression: "hideMenu"
                          }
                        ],
                        staticClass: "navbar-content__params--burger",
                        on: { click: _vm.toggleMenu }
                      },
                      [
                        _c("CompassIcon", {
                          staticClass: "navbar-content__params--burger-icon",
                          attrs: { icon: "menu", size: _vm.burgerIconSize }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "navbar-content__params--burger-label typographies-paragraph-small-regular"
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$l10n.__("Menu")) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu dropdown-right",
                    class: { isVisible: _vm.isVisible }
                  },
                  [
                    _vm.isStaff
                      ? _c("ul", { staticClass: "nav pb-3" }, [
                          _c(
                            "li",
                            {
                              staticClass: "px-3",
                              attrs: { "data-bot": "menu-burger__setting" }
                            },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/settings" } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$l10n.__("Réglages")) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("li", { staticClass: "px-3" }, [
                            _c(
                              "a",
                              {
                                class: _vm.canAccessActionHistory
                                  ? "cpointer"
                                  : "grey cdefault",
                                on: { click: _vm.loadHistory }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$l10n.__("Historique des actions")
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "px-3" }, [
                            _c(
                              "a",
                              {
                                class: { "grey cdefault": !_vm.isAdmin },
                                attrs: {
                                  href: !_vm.isAdmin
                                    ? "javascript:;"
                                    : _vm.legacyUrl
                                },
                                on: { click: _vm.showErrorNotAdmin }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$l10n.__("Modules")) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "px-3" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://marketplace.sellsy.com/",
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$l10n.__("Marketplace")) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.automationsAllowed
                            ? _c("li", { staticClass: "menu-burger" }, [
                                _c(
                                  "a",
                                  { attrs: { href: "/automations/listing" } },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "new" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$l10n.__("Automatisation")
                                            ) +
                                            "\n                                    "
                                        ),
                                        _c("CompassFlag", {
                                          attrs: {
                                            label: _vm.labels.new,
                                            size: "small"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      : _c("ul", { staticClass: "nav pb-3" }, [
                          _c("li", { staticClass: "px-3" }, [
                            _c("a", { attrs: { href: _vm.extProfile } }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$l10n.__("Mon compte")) +
                                  "\n                            "
                              )
                            ])
                          ])
                        ]),
                    _vm._v(" "),
                    _vm.isStaff
                      ? _c(
                          "div",
                          { staticClass: "notifs bt-1 bb-1 pt-3 pb-3 mx-3" },
                          [
                            _vm.canal === "direct"
                              ? [
                                  _vm.accountLevel === "trial"
                                    ? [
                                        _c("p", { staticClass: "m-0" }, [
                                          _c(
                                            "span",
                                            { staticClass: "info-label" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$l10n.__(
                                                      "Compte en essai jusqu’au"
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "info-value" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.trialDeadline) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.isSelfServiceAvailable &&
                                        _vm.isSelfServiceVersioningAllowed
                                          ? _c(
                                              "p",
                                              { staticClass: "acenter m-O" },
                                              [
                                                _c("CompassButton", {
                                                  attrs: {
                                                    label: _vm.$t.__(
                                                      "header.Nav.subscribe"
                                                    )
                                                  },
                                                  on: { click: _vm.subUrl }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    : [
                                        _vm.isSamPlan
                                          ? [
                                              _vm.isselfserviceavailable
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "acenter m-0 pb-2"
                                                    },
                                                    [
                                                      _c("CompassButton", {
                                                        attrs: {
                                                          label: _vm.$t.__(
                                                            "header.Nav.manage_subscription"
                                                          ),
                                                          type: "secondary",
                                                          disabled:
                                                            _vm.enabledButtonSubscriptionV3
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.manageSubscription
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "acenter m-0" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "info-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.$l10n.__(
                                                              "Expire le :"
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "info-value"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.planExpireTime
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : [
                                              _c("p", { staticClass: "m-0" }, [
                                                _c(
                                                  "span",
                                                  { staticClass: "info-label" },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$l10n.__(
                                                            "Formule :"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.planInfos.label
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("p", { staticClass: "m-0" }, [
                                                _c(
                                                  "span",
                                                  { staticClass: "info-label" },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$l10n.__(
                                                            "Expire le :"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "info-value" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.planExpireTime)
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                      ]
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isStaff
                      ? _c("ul", { staticClass: "nav py-3" }, [
                          _c("li", { staticClass: "px-3" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://help.sellsy.com/hc/?lang=" +
                                    _vm.lang,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$l10n.__("Aide")) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "px-3" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://go.sellsy.com/academy?utm_source=saas&utm_medium=menu",
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$l10n.__("Sellsy Academy")) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.accountLevel === "gold"
                            ? _c(
                                "li",
                                { staticClass: "navbar__menu--list" },
                                [
                                  _c(
                                    "a",
                                    { attrs: { href: _vm.accountPrefsUrl } },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$l10n.__("Espace parrainage")
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("CompassIcon", { attrs: { icon: "gift" } })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showRecapButton
                      ? _c("div", { staticClass: "recap-button__wrapper" }, [
                          _c(
                            "button",
                            {
                              staticClass: "recap-button",
                              on: { click: _vm.goToRecap }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "recap-button__label" },
                                [_vm._v(_vm._s(_vm.$t.__("recap.button")))]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src:
                                    "/ressources/logged/img/illustrations/recap2024/shape-recap-no-anim.svg",
                                  width: "110"
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "acenter mb-3" },
                      [
                        _c("CompassButton", {
                          attrs: { label: _vm.$t.__("header.Nav.logout") },
                          on: { click: _vm.logout }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._t("account")
                  ],
                  2
                )
              ],
              1
            )
          ],
          2
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }